import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { animate, stagger } from 'animejs';
import { BienestarAgendaFull } from '../bienestar/BienestarAgenda';
import { BienestarStoreCta } from '../bienestar/BienestarShared';
import { HUB_PATHS, navigateTo } from '../bienestar/bienestarNav';
import '../BienestarPage.css';

const ServiciosBienestarBlock = () => {
  const { t } = useTranslation();
  const pathsRef = useRef(null);

  useEffect(() => {
    const container = pathsRef.current;
    if (!container) return;
    const banners = container.querySelectorAll('.bw-path-banner');
    banners.forEach((b) => {
      b.style.opacity = '0';
      b.style.transform = 'translateY(48px) scale(0.97)';
    });
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animate(banners, {
            opacity: [0, 1],
            translateY: [48, 0],
            scale: [0.97, 1],
            delay: stagger(130),
            duration: 700,
            ease: 'outExpo',
          });
          observer.disconnect();
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="servicios-bienestar-block" id="bienestar-experiencias" aria-labelledby="servicios-bienestar-title">
      <div className="container bw-container">
        <header className="servicios-bienestar-head">
          <span className="bw-hub-kicker">{t('bienestarLandings.hubKicker')}</span>
          <h2 id="servicios-bienestar-title" className="bw-hub-title">{t('bienestarHub.pathsTitle')}</h2>
          <p className="bw-hub-sub">{t('bienestarLandings.hubLead')}</p>
        </header>
      </div>

      <div className="bw-paths-grid servicios-bienestar-paths" ref={pathsRef}>
        {HUB_PATHS.map((path) => (
          <div
            key={path.id}
            className="bw-path-banner"
            role="button"
            tabIndex={0}
            onClick={() => navigateTo(path.path)}
            onKeyDown={(e) => e.key === 'Enter' && navigateTo(path.path)}
          >
            <img
              src={path.src}
              alt=""
              loading="lazy"
              onError={(e) => {
                if (e.currentTarget.src.includes(path.fallbackSrc.split('/').pop())) return;
                e.currentTarget.src = path.fallbackSrc;
              }}
            />
            <div className="bw-path-banner-overlay">
              <span className="bw-path-tag">{t(`bienestarHub.${path.tagKey}`)}</span>
              <h3 className="bw-path-headline">{t(`bienestarHub.${path.titleKey}`)}</h3>
              <p className="bw-path-desc">{t(`bienestarHub.${path.lineKey}`)}</p>
              <button
                type="button"
                className="bw-path-cta"
                onClick={(e) => { e.stopPropagation(); navigateTo(path.path); }}
              >
                {t(`bienestarHub.${path.ctaKey}`)}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="container bw-container servicios-bienestar-agenda">
        <BienestarStoreCta variant="yoga" />
        <BienestarAgendaFull />
      </div>
    </section>
  );
};

export default ServiciosBienestarBlock;
